import { render, staticRenderFns } from "./TaskQuantidades.vue?vue&type=template&id=8e2a7634"
import script from "./TaskQuantidades.vue?vue&type=script&lang=js"
export * from "./TaskQuantidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports